export const TOOLS = {
  SELECT: 'select',
  RECTANGLE: 'rectangle',
  CIRCLE: 'circle',
  FREEHAND: 'freehand',
  ARROW: 'arrow',
  TEXT: 'text',
  RULER: 'ruler',
  ANGLE: 'angle'
};

export const COLORS = [
  { name: 'Red', value: '#EF4444' },
  { name: 'Yellow', value: '#F59E0B' },
  { name: 'Green', value: '#10B981' },
  { name: 'Blue', value: '#3B82F6' },
  { name: 'Purple', value: '#8B5CF6' },
  { name: 'White', value: '#FFFFFF' },
];

export const DEFAULT_PIXEL_TO_MM = 0.25;
